module.exports = __webpack_public_path__ + "static/img/440-2023.6f956ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/440-2023.png
// module id = rrHf
// module chunks = 12